import { motion } from "framer-motion";
import { Check, X, ShoppingCart } from "lucide-react";

const rows = [
  { label: "Editing dasar", free: true },
  { label: "Ekspor tanpa watermark", free: false },
  { label: "Resolusi hingga 4K", free: false },
  { label: "Template & efek premium", free: false },
  { label: "AI Tools & Auto Captions", free: false },
  { label: "Filter & transisi pro", free: false },
  { label: "Update fitur terbaru", free: false },
];

export const CapCutComparison = () => (
  <section className="py-24 bg-white" id="capcut-perbandingan">
    <div className="max-w-3xl mx-auto px-6 sm:px-8">
      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="font-capcut-heading text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-slate-900 text-center mb-14"
      >
        Bedanya? <span className="text-blue-600">Jauh banget</span>.
      </motion.h2>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7 }}
        className="rounded-2xl border border-slate-200 bg-white shadow-[0_8px_30px_rgb(0,0,0,0.04)] overflow-hidden"
        data-testid="capcut-comparison-table"
      >
        <table className="w-full">
          <thead>
            <tr className="border-b border-slate-200 bg-[#F8FAFC]">
              <th className="p-4 sm:p-5 text-left text-xs font-bold uppercase tracking-[0.15em] text-slate-500">Fitur</th>
              <th className="p-4 sm:p-5 text-center text-sm font-semibold text-slate-500 w-20 sm:w-28">Free</th>
              <th className="p-4 sm:p-5 text-center w-20 sm:w-28 bg-blue-50/60">
                <span className="inline-flex items-center gap-1 rounded-full bg-blue-600 text-white text-[10px] font-bold px-3 py-1 uppercase tracking-wide">
                  <ShoppingCart className="w-3 h-3" /> Pro
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={row.label} className={i % 2 ? "bg-slate-50/50" : ""}>
                <td className="p-4 sm:p-5 font-semibold text-slate-800 text-sm">{row.label}</td>
                <td className="p-4 sm:p-5 text-center">
                  <span className={`inline-flex w-6 h-6 rounded-full items-center justify-center ${row.free ? "bg-slate-200" : "bg-slate-100"}`}>
                    {row.free ? <Check className="w-3.5 h-3.5 text-slate-500" strokeWidth={3} /> : <X className="w-3.5 h-3.5 text-slate-300" strokeWidth={3} />}
                  </span>
                </td>
                <td className="p-4 sm:p-5 text-center bg-blue-50/60">
                  <span className="inline-flex w-6 h-6 rounded-full bg-blue-600 items-center justify-center">
                    <Check className="w-3.5 h-3.5 text-white" strokeWidth={3} />
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </motion.div>
    </div>
  </section>
);
